import { useDispatch, useSelector } from "react-redux";
import configGeneratorStore, {
  GeneratorStoreState,
} from "./configureGeneratorStore.js";
import configStore, { StoreState } from "./configureStore.js";

type AppStore = ReturnType<typeof configStore>;
export type AppDispatch = AppStore["dispatch"];

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<StoreState>();

type GeneratorStore = ReturnType<typeof configGeneratorStore>;
type GeneratorDispatch = GeneratorStore["dispatch"];

export const useGeneratorDispatch = useDispatch.withTypes<GeneratorDispatch>();
export const useGeneratorSelector =
  useSelector.withTypes<GeneratorStoreState>();
